import { useLastSearches as useLastSearchesBase } from '@search/core/hooks/useLastSearches';
import { useShallow } from 'zustand/react/shallow';
import { useAppContext } from '../../contexts/AppContext';
export const useLastSearches = () => {
    const [searchModel, pageData, searchIndex, technicalUrl] = useAppContext(useShallow((store) => [store.searchModel, store.pageData, store.searchIndex, store.appConfig.technicalUrl]));
    return useLastSearchesBase({ searchModel, pageData, searchIndex, technicalUrl });
};
